module.exports = __webpack_public_path__ + "static/media/Lobby-Demo_v1.2bd8b9cd.jpg";